module.exports = __webpack_public_path__ + "img/meme-tuba.964685e0.png";